<template>
    <div :class="$attrs.class" v-html="logo"></div>
</template>

<script>
export default {
    props: ["logo"],

    inheritAttrs: false,

    // Since the logo is SVG we need to update the height of the logo
    created() {
        this.$nextTick(() => {
            const svg = this.$el.querySelector("svg");
            if (svg) {
                svg.setAttribute("height", "100%");
            }
        });
    },
};
</script>
